// import { getScreenHeight } from '@/utils/dom'
import type { BasicTableProps, TableActionType } from '../type'
import { unref, ref, onUnmounted } from 'vue'
import { usePageCache } from '@/hooks/usePageCache'
import { deepMergeReplace } from '@/utils/tools'

export function useTable(
  props: BasicTableProps
): [(instance: TableActionType) => void, TableActionType] {
  // 获取表格要展示的高度

  // function getTableHeight () {
  //   const screenHeight = getScreenHeight()
  //   return screenHeight > 500 ? screenHeight - 430 : 700
  // }
  const tableRef = ref<Nullable<TableActionType>>(null)
  const { getCache } = usePageCache()
  function register(instance: TableActionType) {
    onUnmounted(() => {
      tableRef.value = null
    })
    if (instance === unref(tableRef)) return
    tableRef.value = instance
    // usePageCache: 将缓存的搜索条件和传进来的深度合并
    const searchInfo = props.useCache ? getCache()?.table?.searchInfo || {} : {}
    if (props.searchInfo) {
      props.searchInfo = deepMergeReplace(props.searchInfo, searchInfo)
    }
    props && instance.setProps(props)
  }
  function getTableInstance(): TableActionType {
    const table = unref(tableRef)
    return table as TableActionType
  }
  const methods: TableActionType = {
    setProps: (props: Partial<BasicTableProps>) => {
      getTableInstance()?.setProps(props)
    },
    // 设置搜索条件
    setSearchInfo: (props: Recordable) => {
      getTableInstance()?.setSearchInfo(props)
    },
    getSearchInfo: () => {
      return getTableInstance()?.getSearchInfo?.() || {}
    },
    // 重新请求表格数据
    reload: async isInit => {
      return getTableInstance()?.reload(isInit)
    },
    // 获取已选项
    getSectionData: () => {
      return getTableInstance()?.getSectionData()
    },
    // 获取表格数据
    getTableData: (isReactive?: boolean) => {
      return getTableInstance()?.getTableData(isReactive)
    },
    clearSelection: () => {
      getTableInstance()?.clearSelection()
    },
    getSectionDataIds: () => {
      return getTableInstance()?.getSectionDataIds()
    },
    setSortConfig: (props: Recordable) => {
      return getTableInstance()?.setSortConfig(props)
    },
    getRadioData: () => {
      return getTableInstance()?.getRadioData()
    },
    getPaginationInfo: () => {
      return getTableInstance()?.getPaginationInfo
    },
    initTableCache: () => {
      return getTableInstance()?.initTableCache()
    },
    setTotal: (totalNum: number) => {
      return getTableInstance().setTotal(totalNum)
    },
    setPaginationInfo: (info: Recordable) => {
      return getTableInstance().setPaginationInfo(info)
    },
    getPagination: () => {
      return getTableInstance()?.getPagination?.()
    }
  }
  return [register, methods]
}
